import { useEffect, useRef } from "react";
import { arrayOf, bool, shape } from "prop-types";
import { useResizeObserver } from "@hooks";
import { useSetupSessionPlayer } from "./hooks";
import { CenteredCircularProgress } from "@components";
import { ControlPanel, PlayerAnchor, PlayerFrame } from "./components";
import "./style/index.css";

export const SessionPlayer = ({
  events,
  isLoading,
}) => {
  
  const scaleRef = useRef(null);
  
  const {
    playerRef,
    playerContainerRef,
    setupPlayer,
    cleanupPlayer,
    ...controls
  } = useSetupSessionPlayer();
  
  const resizeIframe = () => {
    if (playerRef.current && playerContainerRef.current) {
      const box = playerContainerRef.current.getBoundingClientRect();
      const scaleH = box.width / playerRef.current.iframe.width;
      const scaleV = box.height / playerRef.current.iframe.height;
      const newScale = scaleV > scaleH ? scaleH : scaleV;
      if (newScale !== scaleRef.current) {
        scaleRef.current = newScale;
        playerRef.current.wrapper.style.transform = `translateY(-50%) scale(${scaleRef.current})`;
      }
    }
  };
  
  const containerRef = useResizeObserver(resizeIframe);
  
  useEffect(() => {
    if(!isLoading && playerContainerRef.current) {
      setupPlayer(events);
      resizeIframe();
      playerRef.current.play();
      playerRef.current.on("state-change", resizeIframe);
    }
    
    return () => {
      cleanupPlayer();
    };
  }, [ isLoading, playerContainerRef.current ])
  
  return (
    <PlayerFrame ref={containerRef}>
      {
        isLoading &&
        <CenteredCircularProgress />
      }
      <PlayerAnchor ref={playerContainerRef} />
      <ControlPanel {...controls} />
    </PlayerFrame>
  )
}

SessionPlayer.propTypes = {
  events: arrayOf(shape({
  
  })).isRequired,
  isLoading: bool.isRequired,
}